var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "block-editor youtube-set-moderation-status" },
    [
      _c(
        "section",
        [
          _c("div", { staticClass: "title" }, [_vm._v("Channel ID")]),
          _vm._v(" "),
          _c("TiptapEditor", {
            attrs: {
              placeholder: "YouTube Channel ID",
              "show-attributes": true,
              "automation-mode": "",
            },
            model: {
              value: _vm.clone.channelId,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "channelId", $$v)
              },
              expression: "clone.channelId",
            },
          }),
          _vm._v(" "),
          _c("small", [
            _vm._v("Moderasyon yapılacak yorumun bulunduğu kanal ID'si"),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "section",
        [
          _c("div", { staticClass: "title" }, [_vm._v("Comment ID")]),
          _vm._v(" "),
          _c("TiptapEditor", {
            attrs: {
              placeholder: "YouTube Comment ID",
              "show-attributes": true,
              "automation-mode": "",
            },
            model: {
              value: _vm.clone.commentId,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "commentId", $$v)
              },
              expression: "clone.commentId",
            },
          }),
          _vm._v(" "),
          _c("small", [
            _vm._v("Moderasyon durumu değiştirilecek yorumun ID'si"),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "section",
        [
          _c("div", { staticClass: "title" }, [_vm._v("Moderasyon Durumu")]),
          _vm._v(" "),
          _c(
            "a-select",
            {
              staticClass: "classic-select",
              attrs: { placeholder: "Moderasyon durumu seçiniz" },
              model: {
                value: _vm.clone.moderationStatus,
                callback: function ($$v) {
                  _vm.$set(_vm.clone, "moderationStatus", $$v)
                },
                expression: "clone.moderationStatus",
              },
            },
            [
              _c("a-select-option", { attrs: { value: "published" } }, [
                _vm._v("Yayınla (published)"),
              ]),
              _vm._v(" "),
              _c("a-select-option", { attrs: { value: "heldForReview" } }, [
                _vm._v("İncelemeye Al (heldForReview)"),
              ]),
              _vm._v(" "),
              _c("a-select-option", { attrs: { value: "rejected" } }, [
                _vm._v("Reddet (rejected)"),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "section",
        [
          _c("div", { staticClass: "title" }, [_vm._v("Yorum Sahibini Banla")]),
          _vm._v(" "),
          _c("a-switch", {
            model: {
              value: _vm.clone.banAuthor,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "banAuthor", $$v)
              },
              expression: "clone.banAuthor",
            },
          }),
          _vm._v(" "),
          _vm.clone.banAuthor
            ? _c("small", { staticClass: "ban-warning" }, [
                _vm._v(
                  "Dikkat: Bu kullanıcı kanalınızda bir daha yorum yapamayacak"
                ),
              ])
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }